function hasOwn(value, key) {
  return Boolean(value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, key));
}

function completedSnapshots(value) {
  return (Array.isArray(value) ? value : [])
    .filter((snapshot) => snapshot && snapshot.status === 'completed' && snapshot.asin);
}

function normalizeMarketplace(value) {
  const code = String(value || '').trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? code : '';
}

export function resolveMarketplaceContext({ batchJob = null, savedState = {} } = {}) {
  const batchProductInfo = batchJob?.productInfo || batchJob?.product_info || null;
  const savedProductInfo = savedState.productInfo || null;
  const generationMeta = savedState.listingGenerationMeta || null;
  const businessContext = batchJob?.businessContext || savedState.businessContext || null;
  const snapshotState = savedState.snapshotState
    || (Array.isArray(savedState.snapshots) ? savedState.snapshots[0] : null)
    || null;
  const candidates = [
    batchJob?.marketplace,
    batchProductInfo?.marketplace,
    batchProductInfo?.targetMarket,
    savedState.marketplace,
    generationMeta?.marketplace,
    generationMeta?.mergeMeta?.marketplace,
    generationMeta?.mergeMeta?.businessMeta?.marketplace,
    savedProductInfo?.marketplace,
    savedProductInfo?.targetMarket,
    businessContext?.marketplace,
    businessContext?.targetMarket,
    snapshotState?.marketplace,
  ];
  return candidates.map(normalizeMarketplace).find(Boolean) || '';
}

/**
 * Resolve saved-listing restore context without letting an old UI snapshot
 * override the current batch-job facts. The batch job is the authoritative
 * owner of productInfo, source snapshots and the derived business context.
 */
export function resolveBatchRestoreContext({ batchJob = null, savedState = {} } = {}) {
  const jobSnapshots = completedSnapshots(batchJob?.snapshots);
  const fallbackSnapshots = completedSnapshots(savedState.batchSnapshots || savedState.snapshots);
  const batchSnapshots = batchJob ? jobSnapshots : fallbackSnapshots;
  const snapshotState = batchSnapshots[0]
    || savedState.snapshotState
    || (Array.isArray(savedState.snapshots) ? savedState.snapshots[0] : null)
    || null;

  const productInfo = hasOwn(batchJob, 'productInfo')
    ? (batchJob.productInfo || null)
    : (savedState.productInfo || null);
  const keywordLibrary = hasOwn(batchJob, 'keywordLibrary')
    ? (batchJob.keywordLibrary || null)
    : (savedState.keywordLibrary || null);
  const businessContext = hasOwn(batchJob, 'businessContext')
    ? (batchJob.businessContext || null)
    : (savedState.businessContext || null);

  return {
    batchJob: batchJob || savedState.batchJob || null,
    productInfo,
    keywordLibrary,
    businessContext,
    keywordUsePolicies: businessContext?.keywordUsePolicies
      || savedState.keywordUsePolicies
      || [],
    competitorRoles: businessContext?.competitorRoles
      || savedState.competitorRoles
      || [],
    batchSnapshots,
    snapshotState,
    marketplace: resolveMarketplaceContext({ batchJob, savedState }),
  };
}
